/**
 * spinner modules
 */
export * from './spinner';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-popups/src/spinner/index.js
// module id = 1856
// module chunks = 0